import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'materialize-css/dist/css/materialize.min.css';

import App from './App';

ReactDOM.render((

  <React.StrictMode>
    <App />
  </React.StrictMode>
),
  document.getElementById('root'));

serviceWorker.register();